import { z } from "zod";

export const chatMessageSchema = z.object({
  role: z.string(),
  content: z.string(),
  created_at: z.string(),
  errors: z.array(z.string()).optional().nullable(),
});

export const sessionSchema = z.object({
  id: z.string(),
  name: z.string(),
  created_at: z.string(),
  vote: z.enum(["up", "down"]).nullable().optional(),
});

export const fullSessionSchema = sessionSchema.extend({
  history: z.array(chatMessageSchema),
  read_only: z.boolean(),
});

export const askResponseSchema = z.object({
  errors: z.array(z.string()).nullable(),
  response: chatMessageSchema.nullable(),
  session_id: z.string().nullable(),
});

export type ChatMessage = z.infer<typeof chatMessageSchema>;
export type Session = z.infer<typeof sessionSchema>;
export type FullSession = z.infer<typeof fullSessionSchema>;
